import { TimelineResolution } from "./TimelineResolution";

export class PeriodSpan {
	public Resolution: TimelineResolution;
	public Backward: number;
	public Forward: number;
}